import React, {useCallback} from 'react';
import isInteger from 'lodash/isInteger';

const Number = ({id, config, answer, updateAnswer, missingInfo}) => {
    const {
        min_value: minValue,
        max_value: maxValue,
        answer_optional: answerOptional,
    } = config;

    const {number = ''} = answer;

    const handleChange = useCallback(
        ({target}) => {
            return updateAnswer({number: target.value === '' ? target.value : +target.value});
        },
        [updateAnswer],
    );

    return (
        <div>
            <input
                type="number"
                id={`lesson-block-number-${id}`}
                value={number}
                onChange={handleChange}
                required={!answerOptional}
                min={minValue}
                max={maxValue}
                step={1}
                placeholder="Bitte eingeben"
            />
            {missingInfo && typeof missingInfo === 'string' && (
                <label className="error-label" htmlFor={`lesson-block-number-${id}`}>{missingInfo}</label>
            )}
        </div>
    );
};

const isNum = value => typeof value === 'number';

Number.canContinue = (answer, config) => {
    const {
        min_value: minValue,
        max_value: maxValue,
        answer_optional: answerOptional,
    } = config;

    const number = answer && answer.number;

    if (isNum(number)) {
        if (isNum(minValue) && number < minValue) return `Der kleinste erlaubte Wert is ${minValue}. Bitte korrigieren Sie ihre Antwort.`;
        if (isNum(maxValue) && number > maxValue) return `Der größte erlaubte Wert is ${maxValue}. Bitte korrigieren Sie ihre Antwort.`;

        if(!isInteger(number)) return 'Bitte geben Sie eine ganze Zahl ein.'

        return false;
    }

    return !answerOptional;
}

export default Number;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Number.js